export interface NotificationsState {
    notifications: Notification[]
}

export interface Notification {
    _id: string
    companyId: string;
    userId: string;
    config: {
        type: NotificationType;
        drilldownFocus?: DrilldownFocus;
        pageFocus: NotificationType;
        title: string;
        description: string;
        level: NotificationLevel;
        created_at: Date;
    };
    data: {
        dataId: string;
        name: string;
        distrib: string;
    };
    isArchived: boolean;
}

export enum NotificationType {
    PRODUCTS = "products",
    CLIENTS = "clients",
    WAREHOUSES = "warehouses",
}

export enum DrilldownFocus {
    PRODUCTS = "products",
    CLIENTS = "clients",
    WAREHOUSES = "warehouses",
    PRODUCTS_NOT_DISTRIBUTED = "products not distributed",
    WAREHOUSES_NOT_DISTRIBUTOR = "warehouses not distributor",
    INFORMATIONS = "informations",
}

export enum NotificationLevel {
    HIGH = 1,
    MEDIUM = 2,
    LOW = 3,
}

interface Archive {
    isArchived: boolean
    archiver: string
}
